import { instance } from '../../util/http'
import apis from '../../config/apis'
// 上传身份证 
const upload = (postData) => {
    return instance.post(apis.EmployeePage.Upload, postData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
// 注册店员
const post = (postData) => {
    return instance.post(apis.EmployeePage.Post, postData)
}
// 扫码绑定分享码（获取分享码）
const getbyShareCode = (shareCode) => {
    return instance.get(apis.EmployeePage.ShareCode + "?shareCode=" + shareCode)
}
// 扫绑定用户码绑定分享码
const userByShareCode = (shareCode) => {
    return instance.get(apis.EmployeePage.userByShareCode + "?shareCode=" + shareCode)
}
// 扫绑定用户码 绑定
const bindShareCodeForUser = ({ shareCode }) => {
    return instance.post(apis.EmployeePage.bindShareCodeForUser, { shareCode })
}
const bindPhoneNumberAndShareCodeForUser = ({ phoneNumber,smsCode, shareCode }) => {
    return instance.post(apis.EmployeePage.bindPhoneNumberAndShareCodeForUser, { phoneNumber,smsCode, shareCode })
}
// 后台修改 暂时不知道什么接口
// const addNewUser = ({ phoneNumber, shareCode }) => {
//     return instance.post(apis.EmployeePage.AddNewUser, { phoneNumber, shareCode })
// }
// 如果绑定过手机号绑定分享码
const addNewUser = ({ shareCode }) => {
    return instance.post(apis.EmployeePage.AddNewUser, { shareCode })
}

// 绑定分享码手机号短信 接口
const bindUser = ({ phoneNumber,smsCode, shareCode }) => {
    return instance.post(apis.EmployeePage.BindUser, { phoneNumber,smsCode, shareCode })
}

const balance = () => {
    return instance.get(apis.EmployeePage.Balance)
}

const list = (page, limit) => {
    return instance.get(apis.EmployeePage.List + "?page=" + page + "&limit=" + limit)
}
const agreed = (employeeId) => {
    return instance.put(apis.EmployeePage.Agreed,
        {
            employeeId: employeeId
        })
}
const disagreed = (EmployeeId) => {
    return instance.put(apis.EmployeePage.Disagreed,
        {
            employeeId: EmployeeId
        })
}

const percentageList = () => {
    return instance.get(apis.EmployeePage.PercentageList)
}
// 佣金变更记录
const ownerBalance = (page, limit) => {
    return instance.get(apis.EmployeePage.ownerBalance + "?page=" + page + "&limit=" + limit)
}



export default {
    upload,
    post,
    list,
    getbyShareCode,
    addNewUser,
    bindUser,
    balance,
    agreed,
    disagreed,
    percentageList,
    ownerBalance,
    userByShareCode,
    bindShareCodeForUser,
    bindPhoneNumberAndShareCodeForUser
}